import React, { type FC } from "react";
import { LuX } from "react-icons/lu";
import { useI18next } from "gatsby-plugin-react-i18next";

import { CHAT_ICON_BUTTON } from "@components/chat/chat_helpers";

/**
 * The chat button hides while the chat is open (the panel takes its corner,
 * or the whole screen on phones), so the home view's header (and the
 * unavailable view's) carries this close. A conversation has none: back to
 * home, then close. Escape closes from anywhere.
 */
const ChatCloseButton: FC<{ onClose: () => void }> = ({ onClose }) => {
  const { t } = useI18next();
  return (
    <button
      type="button"
      aria-label={t("close_chat")}
      onClick={onClose}
      className={CHAT_ICON_BUTTON}
    >
      <LuX aria-hidden="true" />
    </button>
  );
};

export default ChatCloseButton;
